/**
 * Handle environment type
 */
export enum EnvironmentType {
  INVISIBLE = 0,
  TECHNICAL_AREA = 1,
  COMMON_AREA = 2,
  ROOM = 3,
  CUSTOMIZED = 4,
  SUITE = 5,
  CISA_ZONE = 10,
  CISA_CATEGORY = 11,
}

/**
 * Handle environment state
 */
export enum EnvironmentState {
  DIRTY = 1,
  CLEAN = 2,
  MAINTANANCE = 3,
  BLOCKED = 4,
  OK = 5,
}

/**
 * Handle environtment state locked
 */
export enum EnvironmentDeviceLockedState {
  NOT_LOCKED = 0,
  PARTIALLY_LOCKED = 1,
  LOCKED = 2,
}

/**
 * Export environment category
 */
export enum EnvironmentCategory {
  UNDEFINED = 0,
  ROOM = 1,
  SUITE = 2,
  JUNIOR_SUITE = 3,
  SINGLE_ROOM = 4,
  DOUBLE_ROOM = 5,
  TRIPLE_ROOM = 6,
  FAMILY_ROOM = 7,
  DORMITORY = 8,
  COMMON_AREA = 9,
  ELAVATOR_FLOOR = 10,
  CABINETS = 11,
  SKI_DEPOSITS = 12,
  EXTERNAL_ACCESS = 13,
  APARTAMENT = 14,
  FLOOR = 15,
  GARAGE = 16,
  STAIRS = 17,
  CONDOMINIUM = 18,
}
